import React from 'react';
import { withRouter } from 'react-router-dom';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import ShowContainer from '../../shared/components/show/ShowContainer';
import FormWrapper from '../../shared/components/form/FormWrapper';

const validationSchema = Yup.object().shape({
  id: Yup.number().required('Required'),
});

const Form = () => (
  <Container>
    <ShowContainer>
      {
        ({ id }) => {
          if (!id) return null;
          const initialValues = { id, weight: null };

          return (
            <FormWrapper
              initialValues={initialValues}
              validationSchema={validationSchema}
              formUrlSuffix={`/${id}/drop_set_weight`}
              formTitle="Drop Weight Confirmation"
              formSubTitle={`Please confirm that you would like to drop the set weight for Shipment #${id}`}
              successModalTitle="Set Weight Dropped!"
              successModalMessage="You'll be sent back to the Shipment index page"
              submitButtonText="Confirm Drop Weight"
              successUrl="/orders/sales-shipments"
            />
          );
        }
      }
    </ShowContainer>
  </Container>
);

export default withRouter(connect()(Form));
